<template>
  <div>
    <div class="row justify-content-between">
      <div class="col-md-6 alerts-col">
        <h2>Upcoming</h2>
        <div v-if="notification" class="alert" v-html="notification"></div>
        <div class="none" v-if="!isLoading && !tours.length">
          <img src="@/assets/icons/search-home.svg" />
          <div class="title">There are currently no tours scheduled</div>
          <div class="sub-title">Tours will show up here when clients book through the external website. You can also manually schedule a tour.</div>
        </div>
        <div class="alerts">
          <div v-for="(tour, i) in tours" :key="tour.id">
            <div class="date" v-if="isDifferentDate(i)">{{ getPrettyDate(tour.timeSlot) }}</div>
            <div :class="['single', {edit: tour.id === editTourId}]" v-on:click="editTour(i)">
              <div class="row">
                <div class="col-md-4 date-col">
                  <div class="calendar">
                    <div class="month">{{ getMonth(tour.timeSlot) }}</div>
                    <div class="day">{{ getDay(tour.timeSlot) }}</div>
                  </div>
                </div>
                <div class="col-md-8 text-col">
                  <div class="headline">{{ tour.name }}</div>
                  <div class="message">{{ getPrettyTime(tour.timeSlot) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 edit-col">
        <EditTour :notify="notify" :tour="tour" :cancel="cancelEdit"/>
      </div>
    </div>
  </div>
</template>

<script>
import EditTour from "../components/EditTour.vue";
import axios from "axios";

export default {
  name: 'Tours',
  data: function () {
    return {
      notification: "",
      tours: [],
      isLoading: true,
      editTourId: null,
      tour: null,
    };
  },
  mounted: function () {
    this.isLoading = true;
    axios.get('/api/tours/read')
      .then((response) => {
        this.isLoading = false;
        this.tours = response.data.tours;

        if (this.$route.params.tourId) {
          for (let i = 0; i < this.tours.length; i++) {
            if (this.tours[i].id == this.$route.params.tourId) {
              this.editTour(i);
              break;
            }
          }
        }
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          let errorStr = "";
          if (error.response.data.error) {
            errorStr = error.response.data.error;
          }
          else if (error.response.data.errors) {
            errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
          }
          else {
            errorStr = error.response.data.message;
          }

          this.error = errorStr;
        }
        else {
          this.error = "Sorry, something went wrong. Please try again later."
        }
      })
  },
  methods: {
    notify: function(tour, isNew, isRemoved) {
      let message = `<strong>${tour.name}</strong>'s tour has been `;
      if (isNew) {
        this.tours.push(tour);
        message += `scheduled.`;
      }
      else if (isRemoved) {
        for (let i = 0; i < this.tours.length; i++) {
          if (this.tours[i].id == tour.id) {
            this.tours.splice(i, 1);
            break;
          }
        }
        message += `removed.`;
        this.tour = null;
        this.editTourId = null;
      }
      else {
        for (let i = 0; i < this.tours.length; i++) {
          if (this.tours[i].id == tour.id) {
            this.$set(this.tours, i, tour);
            break;
          }
        }
        message += `updated.`;
        this.editTourId = null;
        this.tour = null;
      }
      this.notification = message;
      this.orderTours();
    },
    orderTours: function() {
      this.tours.sort((firstEl, secondEl) => {
        if (firstEl.timeSlot >= secondEl.timeSlot) {
          return -1;
        }
        else if (firstEl.timeSlot <= secondEl.timeSlot) {
          return 1;
        }
        else {
          return 0;
        }
      });
    },
    getPrettyDate: function(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },
    getMonth: function(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString('en-US', { month: 'short' });
    },
    getDay: function(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString('en-US', { day: 'numeric' });
    },
    getPrettyTime: function(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    },
    isDifferentDate: function(index) {
      if (index === 0) {
        return true;
      }

      for(let i = 0; i < this.tours.length; i++) {
        if (i === index) {
          let thisDate = new Date(this.tours[i].timeSlot);
          let lastDate = new Date(this.tours[i - 1].timeSlot);
          let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          return thisDate.toLocaleString('en-US', options) != lastDate.toLocaleString('en-US', options);
        }
      }

      return true;
    },
    editTour: function(index) {
      this.editTourId = this.tours[index].id;
      this.tour = this.tours[index];
    },
    cancelEdit: function() {
      this.editTourId = null;
      this.tour = null;
    }
  },
  components: {
    EditTour,
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

h2 {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.2;
  margin: 50px 0 30px;
}

div.alerts-col {
  min-height: 100vh;
  position: relative;

  &:after {
    content: "";
    width: 1px;
    height: 100%;
    background-color: #E9E9E9;
    position: absolute;
    top: 0;
    right: -40px;
  }
}

div.none {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;

  div.title,
  div.sub-title {
    text-align: center;
    color: #4A4A4A;
  }

  div.title {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.2;
    margin: 20px 0 24px;
    max-width: 200px;
  }

  div.sub-title {
    font-size: 0.875rem;
    line-height: 1.43;
    max-width: 310px;
  }
}

div.alerts {
  div.date {
    background-color: #F4F4F3;
    font-size: 0.75rem;
    color: #848484;
    line-height: 1.66;
    padding: 4px 30px;
    min-height: 33px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  }

  div.date + div.single div.text-col {
    &:before {
      display: none;
    }
  }

  div.single {
    padding: 10px 30px;
    transition: background-color 250ms;

    &:hover {
      background-color: #f0f0f0;
    }

    &.edit {
      background-color: var(--accentColor);

      div.calendar {
        border-color: var(--accentColor);

        div.month {
          background-color: black;
        }
      }

      div.headline,
      div.message {
        color: white;
      }
    }
  }

  div.date-col,
  div.text-col {
    padding-top: 1em;
    padding-bottom: 1em;
  }

  div.calendar {
    background: #FFFFFF;
    border: 1px solid #ECECEC;
    box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
    border-radius: 4px;
    overflow: hidden;
    max-width: 90px;

    div.month {
      background-color: var(--accentColor);
      color: white;
      font-size: 0.75rem;
      font-weight: 500;
      text-align: center;
      letter-spacing: 2.1px;
      text-transform: uppercase;
      padding: 4px 0;
      transition: background-color 250ms;
    }

    div.day {
      font-size: 1.875rem;
      letter-spacing: 5.25px;
      color: #222222;
      text-align: center;
      padding: 16px 0;
      line-height: 1;
      padding-left: 5.25px;
    }
  }

  div.text-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      top: -10px;
      left: 0;
      right: 0;
      height: 1px;
      background-color: #EBEBEB;
    }
  }

  div.headline {
    line-height: 1.125;
    color: #4A4A4A;
    margin: 0 0 6px;
    transition: color 250ms;
  }

  div.message {
    color: rgba(#222222, 0.56);
    line-height: 2;
    font-size: 0.75rem;
    transition: color 250ms;
  }
}
</style>
